import { createWebStore } from 'core/store/configureStore';

export const store = createWebStore();
